import { render, staticRenderFns } from "./ChoreContainerHeader.vue?vue&type=template&id=2184c430&"
import script from "./ChoreContainerHeader.vue?vue&type=script&lang=js&"
export * from "./ChoreContainerHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports